// C:\VUE3\platform\src\common\api\cache\materialScoreApi.js
import { sendRequest } from '@/common/sendRequest';

const materialScoreApi = {
  /**
   * material_score 전체 조회 (GET)
   */
  async getAllMaterialScores() {
    return sendRequest('/api/public/common/materialscore/all', {
      method: 'GET',
    });
  },

  /**
   * material_score 캐시 리로드 (POST)
   */
  async reloadMaterialScores() {
    return sendRequest('/api/public/common/materialscore/reload', {
      method: 'POST',
    });
  },
};

export default materialScoreApi;